import perf from './perf';

export const nonProductionMeasure = (name: string, fn: Function) => (
  ...args: any[]
) => {
  perf.mark(`${name}:start`);
  const result = fn(...args);
  perf.mark(`${name}:end`);
  perf.measure(name, `${name}:start`, `${name}:end`);
  return result;
};

export const productionMeasure = (_name: string, fn: Function) => fn;

const measure =
  process.env.NODE_ENV === 'production'
    ? productionMeasure
    : nonProductionMeasure;

export default measure;
